/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import * as constants from "../../constants/teaserList";
import { CLOSE_POPUP } from "../../constants";

function isOpen(state = false, action) {
  if (action.type == constants.OPEN_TEASER_URL_CHANGE_FORM) {
    return true;
  }
  if (
    action.type == CLOSE_POPUP ||
    action.type == constants.ON_TEASER_URL_CHANGE_SUCCESS
  ) {
    return false;
  }
  return state;
}

function errors(state = {}, action) {
  if (action.type == constants.ON_TEASER_URL_CHANGE_FAILED) {
    return action.errors;
  }
  return state;
}

function teaserIds(state = [], action) {
  if (action.type == constants.OPEN_TEASER_URL_CHANGE_FORM) {
    return action.teaserIds;
  }
  if (action.type == CLOSE_POPUP) {
    return [];
  }
  return state;
}

export default combineReducers({
  isOpen,
  teaserIds,
  errors
});
